import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { RoleGuard } from '@/shared/guards/RoleGuard';
import { GUARANTEE_ROLES } from '@/shared/guards/roles';
import { GuaranteeCampaignDetailPage } from './pages/GuaranteeCampaignDetailPage';
import { GuaranteeCampaignsPage } from './pages/GuaranteeCampaignsPage';

export const guaranteeRoutes: RouteObject[] = [
  {
    element: <RoleGuard roles={GUARANTEE_ROLES} />,
    children: [
      {
        path: 'guarantee',
        children: [
          { index: true, element: <Navigate to="campaigns" replace /> },
          { path: 'campaigns', element: <GuaranteeCampaignsPage /> },
          { path: 'campaigns/:id', element: <GuaranteeCampaignDetailPage /> },
        ],
      },
    ],
  },
];
